module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/deskoffice/wood.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/deskoffice/wood.jpg
// module id = 556
// module chunks = 0